import React from 'react';
import { Text, theme } from '@veeqo/ui';
import { ContentType, copy } from 'components/Landing/content';

export const MarketingSubtitle = ({ contentType }: { contentType: ContentType }) => (
  <span
    style={{
      marginTop: theme.sizes[14],
    }}
  >
    <Text variant="headingLarge" style={{ color: 'white' }}>
      {copy[contentType].marketingSubtitleText[0]}
    </Text>{' '}
    <Text variant="headingLarge" style={{ color: '#2578FF' }}>
      {copy[contentType].marketingSubtitleText[1]}
    </Text>{' '}
    <Text variant="headingLarge" style={{ color: 'white' }}>
      {copy[contentType].marketingSubtitleText[2]}
    </Text>
  </span>
);
